export enum BaseURL {
  BASE_URL = "https://apitqf.fte.rmuti.ac.th/api",
  // BASE_URL = "http://localhost:5500/api",
}
